import React from 'react'
import moment from 'moment'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Form } from 'components/shared/Form/Form'

import {
  DEADLINE_FIELD,
  MESSAGES_FIELD,
  MESSAGE_FIELD,
  RECEIVER_FIELD,
  SENDER_FIELD,
  SUBJECT_FIELD,
} from './model'

import styles from './SendTestsMessageForm.module.scss'

const messageFieldError = (errors, stepIndex, fieldName) =>
  errors?.[MESSAGES_FIELD]?.[stepIndex]?.[fieldName]?.message

export const SendTestsMessageForm = ({
  control,
  currentStepIndex,
  formState,
  type,
}) => (
  <Form className={styles.form}>
    <Box className={styles.configuration}>
      <Form.Field
        className={styles.field}
        error={messageFieldError(
          formState.errors,
          currentStepIndex,
          RECEIVER_FIELD,
        )}
        field="input"
        name={`${MESSAGES_FIELD}[${currentStepIndex}].${RECEIVER_FIELD}`}
        label={t`Receiver`}
        isReadOnly
        isRequired
        {...{ control }}
      />
      <Form.Field
        className={styles.field}
        error={messageFieldError(
          formState.errors,
          currentStepIndex,
          DEADLINE_FIELD,
        )}
        field="input"
        name={`${MESSAGES_FIELD}[${currentStepIndex}].${DEADLINE_FIELD}`}
        label={t`Deadline`}
        max={moment()
          .add(60, 'days')
          .format(moment.HTML5_FMT.DATE)}
        min={moment().format(moment.HTML5_FMT.DATE)}
        type="date"
        isRequired
        {...{ control }}
      />
    </Box>
    <Form.Field
      error={messageFieldError(
        formState.errors,
        currentStepIndex,
        SENDER_FIELD,
      )}
      field="input"
      name={`${MESSAGES_FIELD}[${currentStepIndex}].${SENDER_FIELD}`}
      label={t`Sender`}
      isReadOnly
      isRequired
      {...{ control }}
    />
    <Form.Field
      error={messageFieldError(
        formState.errors,
        currentStepIndex,
        SUBJECT_FIELD,
      )}
      field="input"
      name={`${MESSAGES_FIELD}[${currentStepIndex}].${SUBJECT_FIELD}`}
      label={t`Subject`}
      isReadOnly
      isRequired
      {...{ control }}
    />
    <Form.Field
      error={messageFieldError(
        formState.errors,
        currentStepIndex,
        MESSAGE_FIELD,
      )}
      fieldClassName={styles.textarea}
      field="textarea"
      name={`${MESSAGES_FIELD}[${currentStepIndex}].${MESSAGE_FIELD}`}
      label={t`Message`}
      isReadOnly
      isRequired
      {...{ control }}
    />
  </Form>
)
